import { render } from "./AddVillagerModal.vue?vue&type=template&id=acd43a66&scoped=true"
import script from "./AddVillagerModal.vue?vue&type=script&lang=js"
export * from "./AddVillagerModal.vue?vue&type=script&lang=js"

import "./AddVillagerModal.vue?vue&type=style&index=0&id=acd43a66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acd43a66"]])

export default __exports__